import Slide1Img from 'images/main/Slide1.webp';
import Slide2Img from 'images/main/Slide2.webp';
import Slide3Img from 'images/main/Slide3.webp';
import Slide4Img from 'images/main/Slide4.webp';
import Slide5Img from 'images/main/Slide5.webp';
import AboutUsImg from 'images/main/AboutUs.webp';
import NewsImg from 'images/main/News.webp';
import ExpertiseImg from 'images/main/Expertise.webp';
import ProjectsImg from 'images/main/Projects.webp';
import CareersImg from 'images/main/Careers.webp';
import ContactUsImg from 'images/main/ContactUs.webp';
import BgImageImg from 'images/main/BgImage.webp';

import ConstructionGraphBgImg from 'images/main/ConstructionGraphBg.webp';
import WirelessGraphBgImg from 'images/main/WirelessGraphBg.webp';
import EnergyGraphBgImg from 'images/main/EnergyGraphBg.webp';
import EngineeringGraphBgImg from 'images/main/EngineeringGraphBg.webp';
import DeploymentGraphBgImg from 'images/main/DeploymentGraphBg.webp';
import Energy2GraphBgImg from 'images/main/Energy2GraphBg.webp';
import ConsultingGraphBgImg from 'images/main/ConsultingGraphBg.webp';
import DataGraphBgImg from 'images/main/DataGraphBg.webp';
import WirelineGraphBgImg from 'images/main/WirelineGraphBg.webp';
import FulfillmentGraphBgImg from 'images/main/FulfillmentGraphBg.webp';
import OilGraphBgImg from 'images/main/OilGraphBg.webp';
import WaterGraphBgImg from 'images/main/WaterGraphBgo.webp';
import PowerDeliveryGraphBgImg from 'images/main/PowerDeliveryGraphBg.webp';

import ConsultingBusinessHomePageImg from 'images/main/ConsultingBusinessHomePage.webp';
import DataCentersHomePageImg from 'images/main/DataCentersHomePage.webp';
import FulfillmentHomePageImg from 'images/main/FulfillmentHomePage.webp';
import OilGasHomePageImg from 'images/main/OilGasHomePage.webp';
import PowerDeliveryHomePageImg from 'images/main/PowerDeliveryHomePage.webp';
import RenewableEnergyHomePageImg from 'images/main/RenewableEnergyHomePage.webp';
import WaterUtilityHomePageImg from 'images/main/WaterUtilityHomePage.webp';
import WirelineHomePageImg from 'images/main/WirelineHomePage.webp';

export const Slide1 = (Slide1Img as any).src || Slide1Img;
export const Slide2 = (Slide2Img as any).src || Slide2Img;
export const Slide3 = (Slide3Img as any).src || Slide3Img;
export const Slide4 = (Slide4Img as any).src || Slide4Img;
export const Slide5 = (Slide5Img as any).src || Slide5Img;
export const AboutUs = (AboutUsImg as any).src || AboutUsImg;
export const News = (NewsImg as any).src || NewsImg;
export const Expertise = (ExpertiseImg as any).src || ExpertiseImg;
export const Projects = (ProjectsImg as any).src || ProjectsImg;
export const Careers = (CareersImg as any).src || CareersImg;
export const ContactUs = (ContactUsImg as any).src || ContactUsImg;
export const BgImage = (BgImageImg as any).src || BgImageImg;

export const ConstructionGraphBg = (ConstructionGraphBgImg as any).src || ConstructionGraphBgImg;
export const WirelessGraphBg = (WirelessGraphBgImg as any).src || WirelessGraphBgImg;
export const EnergyGraphBg = (EnergyGraphBgImg as any).src || EnergyGraphBgImg;
export const EngineeringGraphBg = (EngineeringGraphBgImg as any).src || EngineeringGraphBgImg;
export const DeploymentGraphBg = (DeploymentGraphBgImg as any).src || DeploymentGraphBgImg;
export const Energy2GraphBg = (Energy2GraphBgImg as any).src || Energy2GraphBgImg;
export const ConsultingGraphBg = (ConsultingGraphBgImg as any).src || ConsultingGraphBgImg;
export const DataGraphBg = (DataGraphBgImg as any).src || DataGraphBgImg;
export const WirelineGraphBg = (WirelineGraphBgImg as any).src || WirelineGraphBgImg;
export const FulfillmentGraphBg = (FulfillmentGraphBgImg as any).src || FulfillmentGraphBgImg;
export const OilGraphBg = (OilGraphBgImg as any).src || OilGraphBgImg;
export const WaterGraphBg = (WaterGraphBgImg as any).src || WaterGraphBgImg;
export const PowerDeliveryGraphBg = (PowerDeliveryGraphBgImg as any).src || PowerDeliveryGraphBgImg;

export const ConsultingBusinessHomePage = (ConsultingBusinessHomePageImg as any).src || ConsultingBusinessHomePageImg;
export const DataCentersHomePage = (DataCentersHomePageImg as any).src || DataCentersHomePageImg;
export const FulfillmentHomePage = (FulfillmentHomePageImg as any).src || FulfillmentHomePageImg;
export const OilGasHomePage = (OilGasHomePageImg as any).src || OilGasHomePageImg;
export const PowerDeliveryHomePage = (PowerDeliveryHomePageImg as any).src || PowerDeliveryHomePageImg;
export const RenewableEnergyHomePage = (RenewableEnergyHomePageImg as any).src || RenewableEnergyHomePageImg;
export const WaterUtilityHomePage = (WaterUtilityHomePageImg as any).src || WaterUtilityHomePageImg;
export const WirelineHomePage = (WirelineHomePageImg as any).src || WirelineHomePageImg;
